import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { DBImportProfile, ImportProfilePayload } from '@/types/import';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  data: ImportProfilePayload;
};

type Response = DBImportProfile;

export const createImportProfile = async (
  scope: RequestScope,
  { data }: RequestParams,
  requestOptions: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<Response>>('/import_profile', data, requestOptions);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
